/* eslint-disable camelcase */
import {
  Create,
  Edit,
  SimpleForm,
  ReferenceInput,
  required,
} from "react-admin";
import { parse } from "query-string";
import { useLocation } from "react-router-dom";

import resources from "../../constants/resources";
import {
  CONTENT_TAG_CREATE_TITLE,
  CONTENT_TAG_EDIT_TITLE,
} from "../../constants/titleConstants";
import CustomToolbar from "../common/CustomToolbar";
import { CONTENT_TAG_HELPER_TEXT } from "../../constants/helperTextConstants";
import {
  AutoCompleteInputField,
  TextInputField,
} from "../../styles/commonStyles";

const ContentTagForm = ({ isEdit, content_id, redirect }) => (
  <SimpleForm
    defaultValues={{ content: content_id }}
    toolbar={<CustomToolbar redirect={redirect} />}
  >
    {isEdit && <TextInputField InputProps={{ disabled: true }} source="id" />}
    <ReferenceInput
      label={resources.CONTENT.label}
      source="content"
      perPage={800}
      reference={resources.CONTENT.url}
    >
      <AutoCompleteInputField
        optionText="name_en"
        helperText={CONTENT_TAG_HELPER_TEXT.content}
        validate={required()}
      />
    </ReferenceInput>
    <TextInputField
      source="key"
      validate={required()}
      helperText={CONTENT_TAG_HELPER_TEXT.key}
    />
    <TextInputField
      source="value"
      validate={required()}
      helperText={CONTENT_TAG_HELPER_TEXT.value}
    />
  </SimpleForm>
);

const ContentTagCreate = props => {
  const { search } = useLocation();
  const { content_id: content_id_string } = parse(search);
  const content_id = content_id_string ? parseInt(content_id_string, 10) : "";
  const redirect = content_id
    ? `/${resources.CONTENT.url}/${content_id}/content_tags`
    : "list";
  return (
    <Create {...props} title={CONTENT_TAG_CREATE_TITLE} redirect={redirect}>
      {ContentTagForm({ ...props, redirect, content_id })}
    </Create>
  );
};

const ContentTagEdit = props => {
  const { isExpandMode, contentId } = props;
  const redirect = () =>
    isExpandMode
      ? `${resources.CONTENT.url}/${contentId}/content_tags`
      : resources.CONTENT_TAGS.url;

  return (
    <Edit {...props} title={CONTENT_TAG_EDIT_TITLE} redirect={redirect}>
      {ContentTagForm({ ...props, isEdit: true, redirect })}
    </Edit>
  );
};

export { ContentTagCreate, ContentTagEdit };
